/**
 * 功能: 批量执行图说ocr
 */
<template lang="pug">
  div
    span 需要ocr的图说 {{ count }}
    el-button.btn.btn-primary(type='primary' :disabled="loading" :size="GLOBAL.SIZE_OF_INPUTBOX" style="margin-left: 20px" @click="batchOcr")
      span 执行ocr
      i.el-icon-loading(v-show="loading")

</template>

<script>
import api from '@/apis/attachment'
export default {
  data () {
    return {
      count: 0,
      loading: false
    }
  },
  created () {
    this.getOcrCount()
  },
  methods: {
    // 获取需要ocr的图说数量
    getOcrCount () {
      api.getOcrCount().then(res => {
        if (res.errCode === 0) {
          this.count = res.data
        } else {
          this.$message({ message: '获取失败,' + res.msg, type: 'error' })
        }
      }).catch(err => {
        this.$message({ message: '获取失败,' + err, type: 'error' })
      })
    },
    // 批量处理ocr图片
    batchOcr () {
      this.loading = true
      api.batchOcr().then(res => {
        if (res.data.msg) {
          this.$notify({ type: 'warning', title: 'ocr处理失败', dangerouslyUseHTMLString: true, message: res.data.msg, duration: 0 })
        }
        if (res.errCode === 0) {
          if (res.data.isError) {
            this.loading = false
            this.count = 0
            this.$message({ type: 'success', message: '执行完成' })
          } else if (res.data.flag) {
            this.batchOcr()
            this.count = this.count - 100 > 0 ? this.count - 100 : 0
          } else {
            this.count = 0
            this.loading = false
            this.$message({ type: 'success', message: '执行完成' })
          }
        } else {
          this.loading = false
          this.$message({ message: 'ocr失败,' + res.msg, type: 'error' })
        }
      }).catch(err => {
        this.loading = false
        this.$message({ message: 'ocr失败,' + err, type: 'error' })
      })
    }
  }
}
</script>

<style>

</style>
